module.exports = __webpack_public_path__ + "src/assets/img/image2-reference.643d9c59.jpg";